import React, { useEffect, useState } from 'react';
import ExpenseHeadField from './ExpenseHeadField';


const AddExpenseHead = () => {
     return (
        <div className='mx-auto w-full p-2 mt-8'>
            <h1 className='text-md text-center bg-primary p-3 text-white rounded-xl'>Add A New Expense Head</h1>
            <ExpenseHeadField></ExpenseHeadField>
        </div>
    );
};

export default AddExpenseHead;